import React from "react";
import "../css/nameAvatar.css";
const NameAvatar = ({ name, type = "normal" }) => {
  const mainColorStyle = { backgroundColor: "var(--main-color)" };

  return type === "normal" ? (
    <div className="cu-name-avatar-main">
      <div>{name}</div>
    </div>
  ) : (
    <div
      className="logo-img cursor-pointer w-[50px] h-[50px]  text-xl rounded-full flex justify-center items-center font-bold "
      style={mainColorStyle}
    >
      {name}
    </div>
  );
};

export default NameAvatar;
